import styled from '@emotion/styled'

import { Hr, theme } from '../Theme'

const Separator = styled(Hr)`
  ${theme.layout.staticWidth(theme.maxWidths.separator)};
`

export default Separator
